import { CircularProgress } from '@mui/material'
import { DeviceLoadingStateContainer } from './styled'

const DeviceLoadingState = () => {
  return (
    <DeviceLoadingStateContainer>
      <CircularProgress />
    </DeviceLoadingStateContainer>
  )
}

export default DeviceLoadingState
